module.exports = __webpack_public_path__ + "static/media/7.e2ebd72b.png";